import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import { DateIconSvg, ListIconSvg, PersonIconSvg } from "../../images/SvgIcons";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AdminBrokerConfirmation(props) {
  const { open, setOpen, flag, brokerRemoveFun, handleClose, adminRemove } =
    props;
  // const [open, setOpen] = React.useState(false);
  console.log(flag, "flagggggggggggggg", adminRemove);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [personName, setPersonName] = React.useState([]);

  const handleChangeyes = () => {
    brokerRemoveFun();
  };
  const handleChangeno = () => {
    // setClearFilterValue(false);
    // resetFilter(false);
    handleClose();
    console.log("called no");
  };
  return (
    <>
      <Dialog
        className="user-filter-popup manage-user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        // onClose={resetFilter}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px", pb: "6px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">
            {flag == false
              ? "Broker to Admin Role"
              : adminRemove == true
              ? "Remove Admin Role"
              : "Remove Broker Role"}
          </Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <p className="label">
            {flag == false
              ? `Changing the role type of this broker to admin will result in any open billing statements associated with this user being moved to the
            'Orphaned Bills' list. Are you sure you want to proceed?`
              : adminRemove == true
              ? "Are you sure you want to remove the admin role? This action will revoke all administrative privileges and access rights currently granted to this user."
              : `Removing the broker role from this user will result in any open billing statements associated 
with them being moved to the 'Orphaned Bills' list. Are you sure you want to proceed?`}
          </p>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", pt: "21px" }}
        >
          <Button className="filter-btn" onClick={brokerRemoveFun}>
            Proceed
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
